module.exports = __webpack_public_path__ + "static/media/AppStore.f5590c44.png";